import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ROUTES } from './api-routes';
import { SalesAgentCreate, SalesAgentGet } from '../interfaces/sales-agents-interfaces';
import { map, Observable } from 'rxjs';
import { DEFAULT_JSON_HEADERS } from './headers.config';

@Injectable({
  providedIn: 'root'
})
export class SalesAgentsService {

  constructor(private http: HttpClient) { }

  createSalesAgent(data: SalesAgentCreate): Observable<any> {
    const payload = JSON.stringify(data);

    return this.http.post<SalesAgentGet>(
      `${API_ROUTES.SALES_AGENTS.DEFAULT}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  updateSalesAgent(id: string, data: SalesAgentCreate): Observable<any> {
    const payload = JSON.stringify(data);

    return this.http.post<SalesAgentGet>(
      `${API_ROUTES.SALES_AGENTS.DEFAULT}${id}`,
      payload,
    );
  }

  getSalesAgent(id: string): Observable<any> {
    return this.http.get<SalesAgentGet>(
      `${API_ROUTES.SALES_AGENTS.DEFAULT}${id}`,
    );
  }

  deleteSalesAgent(id: string): Observable<any> {
    return this.http.delete<SalesAgentGet>(
      `${API_ROUTES.SALES_AGENTS.DEFAULT}${id}`,
    );
  }

  getSalesAgents(next_page: number = 1, per_page: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page);

    return this.http.get<any>(
      API_ROUTES.SALES_AGENTS.DEFAULT,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  getSalesAgentsPeriod(next_page: number = 1, per_page: number = 20, referred_users_from: string, referred_users_to: string): Observable<any> {
    const params = new HttpParams()
      .set('next_page', next_page)
      .set('per_page', per_page)
      .set('referred_users_from', referred_users_from)
      .set('referred_users_to', referred_users_to);

    return this.http.get<any>(
      API_ROUTES.SALES_AGENTS.PERIOD,
      { params: params, observe: 'response' }
    ).pipe(
      map(response => {
        const totalCount = response.headers?.get('x-total-count') ? Number(response.headers.get('x-total-count')) : 0;
        return { data: response.body.data || [], totalCount: totalCount };
      }));
  }

  trackSalesAgent(agent_id: string): Observable<any> {
    return this.http.post<SalesAgentGet>(
      `${API_ROUTES.SALES_AGENTS.DEFAULT}${agent_id}/referrals`,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

}
